<script>
import textInput from './textInput/textInput.vue';
import Vue from 'vue';
export default Vue.extend(textInput);
</script>
